export { default } from './DistributionBar';